/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-native/no-inline-styles */
import * as S from './styles';
import React, {useEffect} from 'react';
import theme from '../../../global/styles/theme';
import TextDefault from '../../../components/TextDefault';
import Button from '../../../components/Button';
import {yupResolver} from '@hookform/resolvers/yup';
import {useForm} from 'react-hook-form';
import {schemaRegister} from '../../../utils/schema';
import Input from '../../../components/Input';
import {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {CommonActions, useNavigation} from '@react-navigation/native';
import Toast from 'react-native-toast-message';
import {toastConfig} from '../../../components/Toast';
import {signUp} from '../../../services/auth';
import {updateUser} from '../../../store/modules/user/actions';
import {RootState} from '../../../store';
import KeyboardScrollView from '../../../components/KeyboardScrollView';
import {StatusBarContainer} from '../../../components/StatusBar';
import {getCep} from '../../../services/cep';
import {isOver18} from '../../../utils/functions';

const registerResolver = {
  resolver: yupResolver(schemaRegister),
};

export default function RegisterScreen() {
  const {
    control,
    handleSubmit,
    formState: {errors},
    watch,
    setValue,
  } = useForm(registerResolver);
  const watchCep = watch('cep');

  const [isLoading, setIsLoading] = useState(false);

  const navigation: any = useNavigation();
  const appTheme = useSelector((state: RootState) => state.config.appTheme);
  const dispatch = useDispatch();

  async function handleRegisterPress(data: any) {
    if (data.password === data.confirmPassword) {
      delete data.confirmPassword;
      const verifyBirthDate = isOver18(data.birthDate);
      if (!verifyBirthDate) {
        return Toast.show({
          type: 'error',
          text1: 'Restrição de acesso para maiores de 18 anos.',
        });
      }
      setIsLoading(true);
      const type = data.document.length === 14 ? 'PF' : 'PJ';
      await signUp({...data, type})
        .then(async registerInfo => {
          setIsLoading(false);
          const dataUser = registerInfo?.data?.result;
          // @ts-ignore
          dispatch(updateUser(dataUser));
          return navigation.dispatch(
            CommonActions.reset({
              index: 0,
              routes: [{name: 'MainTab'}],
            }),
          );
        })
        .catch(error => {
          setIsLoading(false);
          Toast.show({
            type: 'error',
            text1:
              error?.response?.data?.message ||
              'Ocorreu um erro, tente novamente mais tarde!',
          });
        });
    } else {
      Toast.show({
        type: 'error',
        text1: 'As senhas precisam ser iguais.',
      });
    }
  }

  const getAddressInfo = async () => {
    const response = await getCep(watchCep || '');
    if (response) {
      setValue('neighborhood', response.bairro);
      setValue('city', response.localidade);
      setValue('address', response.logradouro);
      setValue('district', response.uf);
    }
  };

  useEffect(() => {
    if (watchCep?.length === 9) {
      getAddressInfo();
    } else {
      setValue('neighborhood', '');
      setValue('address', '');
      setValue('district', '');
      setValue('city', '');
    }
  }, [watchCep]);

  return (
    <>
      <StatusBarContainer />
      <S.Container>
        <S.ContainerArea appTheme={appTheme}>
          <KeyboardScrollView justifyContent="flex-start">
            <S.Body>
              <S.Row>
                <S.ButtonGoBack onPress={() => navigation.goBack()}>
                  <S.IconImage
                    color={theme.colors(appTheme).white}
                    size={26}
                    name="arrow-left"
                  />
                </S.ButtonGoBack>
                <TextDefault
                  fontSize={20}
                  color={theme.colors(appTheme).white}
                  text="Bem-vindo ao DSS Exchange"
                  fontFamily={theme.fonts.family.opensans.semi_bold}
                  style={{flex: 1}}
                />
              </S.Row>
              <S.Column>
                <Input
                  title="Nome"
                  errors={errors}
                  placeholder="Digite seu nome"
                  control={control}
                  name="name"
                  width="100%"
                  hideBorder
                />
                <Input
                  title="E-mail"
                  errors={errors}
                  placeholder="Digite seu e-mail"
                  control={control}
                  name="email"
                  width="100%"
                  marginTop={20}
                  hideBorder
                />
                <Input
                  title="Telefone"
                  errors={errors}
                  placeholder="Digite seu telefone"
                  control={control}
                  name="telephone"
                  width="100%"
                  marginTop={20}
                  hideBorder
                  mask="mobilePhone"
                  keyboardType="phone-pad"
                />
                <Input
                  title="CPF/CNPJ"
                  errors={errors}
                  placeholder="Digite seu CPF/CNPJ"
                  control={control}
                  name="document"
                  width="100%"
                  marginTop={20}
                  hideBorder
                  mask="cpfOrCnpj"
                  keyboardType="phone-pad"
                />
                <Input
                  title="CEP"
                  errors={errors}
                  placeholder="Digite seu cep"
                  control={control}
                  name="cep"
                  width="100%"
                  marginTop={20}
                  hideBorder
                  mask="cep"
                  keyboardType="phone-pad"
                />
                <Input
                  title="Endereço"
                  errors={errors}
                  placeholder="Digite seu endereço"
                  control={control}
                  name="address"
                  width="100%"
                  marginTop={20}
                  hideBorder
                />
                <Input
                  title="Cidade"
                  errors={errors}
                  placeholder="Digite sua cidade"
                  control={control}
                  name="city"
                  width="100%"
                  marginTop={20}
                  hideBorder
                />
                <Input
                  title="Bairro"
                  errors={errors}
                  placeholder="Digite seu bairro"
                  control={control}
                  name="neighborhood"
                  width="100%"
                  marginTop={20}
                  hideBorder
                />
                <Input
                  title="Estado"
                  errors={errors}
                  placeholder="Digite seu estado"
                  control={control}
                  name="district"
                  width="100%"
                  marginTop={20}
                  hideBorder
                />
                <Input
                  title="Número"
                  errors={errors}
                  placeholder="N"
                  control={control}
                  name="numberAddress"
                  width="100%"
                  marginTop={20}
                  hideBorder
                  mask="number"
                  keyboardType="phone-pad"
                />
                <Input
                  title="Data de nascimento"
                  errors={errors}
                  control={control}
                  name="birthDate"
                  marginTop={10}
                  width="100%"
                  placeholder="__/__/____"
                  mask="datetime"
                  keyboardType="numeric"
                  hideBorder
                />
                <Input
                  title="Senha"
                  errors={errors}
                  placeholder="Digite sua senha"
                  control={control}
                  name="password"
                  type="password"
                  width="100%"
                  marginTop={20}
                  hideBorder
                />
                <Input
                  title="Confirmar senha"
                  errors={errors}
                  placeholder="Confirme sua senha"
                  control={control}
                  name="confirmPassword"
                  type="password"
                  width="100%"
                  marginTop={20}
                  hideBorder
                />
              </S.Column>
              <Button
                title="CRIAR CONTA"
                onPress={handleSubmit(handleRegisterPress)}
                fontFamily={theme.fonts.family.opensans.bold}
                marginTop={40}
                marginBottom={40}
                isLoading={isLoading}
                width="90%"
              />
            </S.Body>
          </KeyboardScrollView>
        </S.ContainerArea>
        <Toast config={toastConfig} />
      </S.Container>
    </>
  );
}
